<div class="schedule">
  <div class="row schedule-title">
    <div class="col">
      <div *ngIf="scheduleDate" class="schedule-date"> {{ scheduleDate }}</div>
      <span *ngIf="additionalDates.length > 0">
        <div *ngFor="let additionalDate of additionalDates" class="schedule-date"> {{ additionalDate }}
        </div>
      </span>
    </div>
    <div class="col schedule-caption">
      <h3 *ngIf="scheduleCaption">{{ scheduleCaption | translate }}</h3>
    </div>
  </div>
  <div *ngIf='scheduleGrouppedDays && scheduleGrouppedDays.length > 0'>
    <div class="row justify-content-center">
      <div class="col-auto" *ngFor="let scheduleGrouppedDay of scheduleGrouppedDays">
        <span class="schedule-weekdays"> {{ getShortWeekDayRangeName(scheduleGrouppedDay.dayRange) }} </span>
        <div *ngIf="scheduleGrouppedDay.workingTime && scheduleGrouppedDay.workingTime.length > 0">
          <div *ngFor="let workingTime of scheduleGrouppedDay.workingTime" class="schedule-time">
            {{ getTimeRange(workingTime) }}
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
</div>
